/*
 * Copyright 2026 Intuition Robotics ltd
 */
import type {ApiWithBody} from "@intuitionrobotics/thunderstorm";

export const CheckinSectionName = "daily_checkin";
export const CheckinAlertType_Missed = "daily_checkin_missed";
export const CheckinAlertType_AllDone = "daily_checkin_all_done";

export type CheckinActivityItem = {
    agentId: string;
    lastInteraction?: number;
    lastInteractionOverride?: number;
    // Last time the device reported runtime status to the server. Sourced from
    // the runtime-status table on q-server; piggybacks on /checkin/morning-activity
    // to avoid a second roundtrip while check-in is the only consumer. If a
    // dedicated connectivity feed is needed later, lift this into its own endpoint.
    lastConnected?: number;
};

export type Body_CheckinOverride = { unitId: string };
export type Body_CheckinMorningActivity = { unitIds: string[] };
export type Response_CheckinMorningActivity = CheckinActivityItem[];

export type Api_CheckinOverride = ApiWithBody<"/v1/check-in/override", Body_CheckinOverride, void>;
export type Api_CheckinMorningActivity =
    ApiWithBody<"/v1/check-in/morning-activity", Body_CheckinMorningActivity, Response_CheckinMorningActivity>;
// Hack endpoint for QA: fires the daily cron synchronously, exactly as the
// scheduled function would. Subject to the same per-org tz guard and
// single-shot-per-day guard as the cron.
export type Api_CheckinTriggerDaily = ApiWithBody<"/v1/check-in/trigger-daily", {}, void>;
